export default __webpack_public_path__ + "static/media/RAP_high_resolution_web_1.125ba669.png";